import React from "react"
import styles from "./FvVideoPreview.module.scss"
import { IPlacementDataTable } from "../types/placement"
import { Image, Tooltip } from "antd"

interface FvVideoPreviewProps {
  placement: IPlacementDataTable
}

const STATUS_LABELS: Record<string, string> = {
  APPROVED: "approved",
  PENDING: "in moderation",
  REJECTED: "rejected",
}

const STATUS_STYLE: Record<string, string> = {
  APPROVED: styles.statusApproved,
  PENDING: styles.statusPending,
  REJECTED: styles.statusRejected,
}

const resolveStatus = (status?: string): { label: string; className?: string } => {
  if (!status) {
    return { label: "" }
  }
  return {
    label: STATUS_LABELS[status] ?? status.toLowerCase(),
    className: STATUS_STYLE[status],
  }
}

const TOOLTIP_INNER_STYLE = {
  padding: 0,
  background: "transparent",
  boxShadow: "none",
  borderRadius: 4,
  lineHeight: 0,
}

const renderCover = (coverUrl?: string) => {
  if (coverUrl) {
    return <Image src={coverUrl} alt="featured video cover" className={styles.cover} />
  }
  return <span className={styles.emptyCover}>no asset</span>
}

const FvVideoPreview: React.FC<FvVideoPreviewProps> = ({ placement }) => {
  const status = resolveStatus(placement.extensionModerationStatus)

  return (
    <span className={styles.thumbnail}>
      {renderCover(placement.renderedCoverImageUrl)}
      <span>
        <div className={styles.label}>Featured Videos</div>
        {status.label && (
          <div className={`${styles.status} ${status.className ?? ""}`}>{status.label}</div>
        )}
      </span>
    </span>
  )
}

export default FvVideoPreview
